import request from '@/utils/request'
import qs from 'qs'

const api = {
  list: '/patient/list', //获取用就诊人列表
  addUser: '/patient/bind', //添加就诊人
  unbind: '/patient/unbind', //解除绑定
  setDefault: '/patient/setDefault', //设置默认就诊人
  getUser:'/patient/getUser',//获取默认就诊人信息
  getDict:'/open/getDict',//查询字典
}
//获取该openid下的所有用户数据
export function getUserList() {
  return request({
    url: api.list,
    method: 'get'
  })
}
//添加用户
export function addUser(parameter) {
  return request({
    url: api.addUser,
    method: 'post',
    data: qs.stringify(parameter)
  })
}
//用户解除绑定
export function unbind(parameter) {
  return request({
    url: api.unbind,
    method: 'post',
    data: qs.stringify(parameter)
  })
}
//设置默认就诊人
export function setDefault(parameter) {
  return request.post(
    api.setDefault,
    qs.stringify(parameter)
  )
}

//设置默认就诊人
export function getUser(parameter) {
  return request.post(
    api.getUser,
    qs.stringify(parameter)
  )
}

//查询字典
export function getDict(parameter) {
  return request.post(
    api.getDict,
    qs.stringify(parameter)
  )
}